/**
 * @flow
 * @relayHash b8a4669e8b7872a2c8b737bff2df0c21
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type CreateEventFormInput = {
  clientMutationId?: ?string,
  title: string,
  user_id: string,
  booking_status?: ?BookingStatus,
  referral_source?: ?string,
  notes?: ?string,
  visibility?: ?UserEventVisibility,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  contacts?: ?$ReadOnlyArray<?EventCreateContact>,
  user_event_segments?: ?$ReadOnlyArray<?EventCreateUserEventSegment>,
};
export type EventCreateContact = {
  role: string,
  first_name: string,
  last_name?: ?string,
  emails?: ?$ReadOnlyArray<?UserContactEmailInput>,
  addresses?: ?$ReadOnlyArray<?UserContactAddressInput>,
  phones?: ?$ReadOnlyArray<?UserContactPhoneInput>,
};
export type UserContactEmailInput = {
  label: string,
  address: string,
};
export type UserContactAddressInput = {
  label: string,
  line1: string,
  line2?: ?string,
  city?: ?string,
  province: string,
  postal_code: string,
  country: string,
};
export type UserContactPhoneInput = {
  label: string,
  number: string,
};
export type EventCreateUserEventSegment = {
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type CreateEvent_CreateEventFormMutationVariables = {|
  input: CreateEventFormInput
|};
export type CreateEvent_CreateEventFormMutationResponse = {|
  +createEventForm: ?{|
    +event: ?{|
      +id: string
    |}
  |}
|};
export type CreateEvent_CreateEventFormMutation = {|
  variables: CreateEvent_CreateEventFormMutationVariables,
  response: CreateEvent_CreateEventFormMutationResponse,
|};
*/


/*
mutation CreateEvent_CreateEventFormMutation(
  $input: CreateEventFormInput!
) {
  createEventForm(input: $input) {
    event {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateEventFormInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createEventForm",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateEventFormInput!"
      }
    ],
    "concreteType": "CreateEventFormPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "CreateEvent_CreateEventFormMutation",
  "id": null,
  "text": "mutation CreateEvent_CreateEventFormMutation(\n  $input: CreateEventFormInput!\n) {\n  createEventForm(input: $input) {\n    event {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CreateEvent_CreateEventFormMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateEvent_CreateEventFormMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b27500604c62023cfc11ff1e0b0109f3';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Create/__generated__/CreateEvent_CreateEventFormMutation.graphql.js